import React from 'react'
import _ from 'lodash'

/**
 * @description We use this function to join multi path
 * @param  {...any} paths example 'http://localhost:8080/', '/upload/img.jpg'
 * @returns "http://localhost:8080/upload/img.jpg"
 */
export function joinPaths(...paths) {
    return paths.map((part, i) => {
      if (i === 0) {
        return part.trim().replace(/[\/]*$/g, '')
      } else {
        return part.trim().replace(/(^[\/]*|[\/]*$)/g, '')
      }
    }).filter(x=>x.length).join('/')
}

/**
 * @description We check if we are on server mode or client
 * @returns boolean
 */
export const isClient = typeof window !== 'undefined'



// Handle errors in response
export const handleErrors = (error) => {
    if(error.response && error.response.status){
        switch (error.response.status) {
            case 400:
                    // get form_errors from response
                    let errors = {}
                    errors = _.get(error, 'response.data.form_errors')
                    errors = {
                        ...errors,
                        ..._.get(error, 'response.data.response.errors')
                    }
                    if (errors) {
                        const errorsList = []
                        // Loop through errors
                        _.forOwn(errors, (values, key) => {
                            if(typeof values[0] === 'string'){
                                // If the value is a string, add key value pair to errorsList
                                errorsList.push(`${key.toLocaleUpperCase()}: ${values[0]}.`)
                            }else{
                                // If the value is not a string, loop through the values add key value pair to errorsList
                                _.forOwn(values[0], (v, k) => {
                                    errorsList.push(`${k.toLocaleUpperCase()}: ${v[0]}.`)
                                })
                            }
                        })
                        return errorsList.join('\n')
                    } else {
                        return "Un problème est survenu"
                    }

            case 401:
                // Handle unauthorized error
                return "Vous n'avez pas le droit d'effectuer cette opération."

            default:
                return "Service inaccessible pour le moment."
        }
    }else{
        // If error has no response return the message of error
        return error.message
    }
}

export function getEnvConfig(variableName: string, defaultValue?: any) {
    const variableValue = (globalThis.ENV && globalThis.ENV[variableName]) || process.env[variableName]
    if (variableValue) {
        return variableValue
    }
    if (defaultValue) {
        return defaultValue
    }
    if (process.env.NODE_ENV === 'development') {
        console.error(`Environment variable ${variableName} is not defined`)
    }
}
